import { Attachment, IAttachment } from '@app/models/Attachment'
import { List, Record } from 'immutable'
import { RelatedFileSource } from './enums'

export interface IRelatedAttachment {
  readonly photos: List<IAttachment>
  readonly attachments: List<IAttachment>
  readonly referenceId: string
  readonly name: string
  readonly sourceType: RelatedFileSource
}

const RelatedAttachmentRecord = Record({
  attachments: List<Attachment>(),
  name: '',
  photos: List<Attachment>(),
  referenceId: '',
  sourceType: RelatedFileSource.Property,
})

export class RelatedAttachment extends RelatedAttachmentRecord
  implements IRelatedAttachment {
  public static fromJS(initialState?: Partial<IRelatedAttachment>) {
    if (!initialState) {
      return new RelatedAttachment()
    }

    const { attachments, photos, ...rest } = initialState

    return new RelatedAttachment({
      attachments: attachments
        ? List(attachments.map((a) => Attachment.fromJS(a)))
        : undefined,
      photos: photos ? List(photos.map((a) => Attachment.fromJS(a))) : undefined,
      ...rest,
    })
  }

  public readonly photos: List<Attachment>
  public readonly attachments: List<Attachment>
  public readonly referenceId: string
  public readonly name: string
  public readonly sourceType: RelatedFileSource

  constructor(initialState?: Partial<RelatedAttachment>) {
    initialState ? super(initialState) : super()
  }
}
